'use strict';

angular.module('TurneroApp').component('coTasasHistorico', {
    bindings: {
        usuario: '<'
    },
    controller: [
        '$scope',
        'utilsService',
        '$rootScope',
        'TRSService',
        function ($scope, utilsService, $rootScope, TRSService) {
            var ctrl = this;
            ctrl.MotrarTable = false;
            ctrl.filter = false;

            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };
            
            ctrl.$onInit = function () {
                $rootScope.$broadcast('esHome', false);
                $rootScope.$broadcast('esCalendario', false);
                $rootScope.$broadcast('esTasaRetributiva', true);
                ctrl.limpiarFiltro();
            };

            ctrl.$onChanges = function () {
                $rootScope.$broadcast('esHome', false);
                $rootScope.$broadcast('esCalendario', false);
                $rootScope.$broadcast('esTasaRetributiva', true);
                ctrl.grillaReload();
            };

            ctrl.limpiarFiltro = function () {
                ctrl.query = {
                    page: 1,
                    limit: 10,
                    filter: ""
                };
            };

            ctrl.removeFilter = function () {
                ctrl.query.filter = '';
                ctrl.grillaReload();
                ctrl.filter = false;
            };

            ctrl.mostrarBuscar = function () {
                ctrl.filter = true;
                ctrl.focusBuscar = true;
            };
            
            ctrl.grillaReload = function () {
                if (!ctrl.query.filter || ctrl.query.filter.length > 2) {
                    ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos)
                }
            };

            ctrl.getData = function (page, limit, tipo, callback) {
                ctrl.promise = TRSService.Get_Tasas_Historial_Pagos({
                    'filtro.nro_Pagina': page,
                    'filtro.tam_Pagina': limit,
                    'filtro.texto': ctrl.query.filter
                }).$promise.then(function (res) {
                    callback(tipo, res);
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            }

            function cargarDatos(tipo, data) {
                if (tipo == 'grid') {
                    ctrl.tasas_historial = data.Data;
                    ctrl.pagination.total = data.Paging.Reg_Totales;
                }
            }
        }
    ],
    template: require('./tasasHistorico.html')
});


// WEBPACK FOOTER //
// ./app/components/turnos/tasasRetributivas/tasasHistoricoComponent.js